import ResizeObserver from "resize-observer-polyfill";
import { useRef, useEffect, useState } from "react";

export const useMeasure = ({ ref }) => {
  const [measurement, setMeasurement] = useState({});
  const resizeObserver = useRef();

  useEffect(
    () => {
      if (resizeObserver.current) {
        resizeObserver.current.disconnect();
        resizeObserver.current = undefined;
      }
  
      resizeObserver.current = new ResizeObserver(() => {
        if(ref.current) setMeasurement(ref.current.getBoundingClientRect());
      });
  
      resizeObserver.current.observe(ref.current);
    },
    [ref]
  );

  return measurement;
};